export const environment = {
	production: false,
	oasisApiBase: 'https://exylkkc1e1.execute-api.us-gov-east-1.amazonaws.com/api',
	cognito: {
		issuer: 'https://cognito-idp.us-gov-east-1.amazonaws.com/us-gov-east-1_ypVrvy36q',
		clientId: '27oceusherbmcs1j6b0vuq5ejh',
		/**
		 * Cognito user-pools API host, read only by `CognitoSignupService` for the
		 * unauthenticated resend/confirm calls behind `/verify`. FIPS host on purpose,
		 * matching the `auth-fips` domain the discovery document advertises — not
		 * derived from `issuer`, which is the non-FIPS host.
		 */
		idpEndpoint: 'https://cognito-idp-fips.us-gov-east-1.amazonaws.com',
		hostedDomain: 'https://asb-cap-sam-persistent-uat-oasis-external-v2.auth-fips.us-gov-east-1.amazoncognito.com',
		/**
		 * Space-delimited scopes. Cognito does not implement
		 * `offline_access`; refresh tokens come from the code grant anyway.
		 */
		scopes: 'openid email profile',
		/**
		 * Must match a registered CallbackURL on the app client exactly.
		 * For local end-to-end testing against the uat pool, temporarily swap
		 * this to 'http://localhost:4200/auth/callback' — uat registers it
		 * (LocalhostRedirect: 'true' in template-persistent.yaml).
		 */
		redirectUri: 'https://ax1-uat.usdoj.gov/auth/callback',
		responseType: 'code',
		/** Bare origin, no trailing slash — must match a registered LogoutURL. */
		postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
	},
};
